// Helper: Chuyển đổi tiếng Việt có dấu thành không dấu
export const removeVietnameseTones = (str) => {
  if (!str) return "";
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
  str = str.replace(/Đ/g, "D");
  // Loại bỏ các ký tự đặc biệt, chỉ giữ lại chữ cái, số, khoảng trắng
  str = str.replace(/[^a-zA-Z0-9\s]/g, "");
  // Thay khoảng trắng bằng dấu gạch dưới
  str = str.replace(/\s+/g, "_");
  // Loại bỏ các dấu gạch dưới liên tiếp
  str = str.replace(/_+/g, "_");
  // Loại bỏ dấu gạch dưới ở đầu và cuối
  str = str.replace(/^_+|_+$/g, "");
  return str;
};

// Helper: Tạo tên file Excel với ghi chú và thời gian
export const generateExcelFileName = (note = "") => {
  const now = new Date();
  const dateStr = now.toISOString().split('T')[0].replace(/-/g, '-');
  const timeStr = now.toTimeString().split(' ')[0].replace(/:/g, '-');
  const noteStr = note ? `${removeVietnameseTones(note)}_` : "";
  // Format: DanhSachSDT_ChamSoc_[ghi_chu]_YYYY-MM-DD_HH-MM-SS.xlsx
  return `DanhSachSDT_ChamSoc_${noteStr}${dateStr}_${timeStr}.xlsx`;
};
